/**
 * check whether the schema belongs to section type
 * @param jsonSchema json schema
 * @param uiSchema ui schema
 */
export function getIsSectionBlock(
  jsonSchema: JSONSchema | undefined,
  uiSchema: UISchema | undefined,
) {
  if (!jsonSchema || !uiSchema) return false;
  return uiSchema?.["ui:widget"] !== "rating" && jsonSchema?.type === "object";
}
